export const SURVEYTEMPLATE_LOADING = "SURVEYTEMPLATE_LOADING";
export const SURVEYTEMPLATE_RESET = "SURVEYTEMPLATE_RESET";
export const GET_SURVEYTEMPLATE = "GET_SURVEYTEMPLATE";
export const GET_SURVEYTEMPLATE_SUCCESS = "GET_SURVEYTEMPLATE_SUCCESS";
export const GET_SURVEYTEMPLATE_FAIL = "GET_SURVEYTEMPLATE_FAIL";
export const DELETE_SURVEYTEMPLATE = "DELETE_SURVEYTEMPLATE";
export const DELETE_SURVEYTEMPLATE_SUCCESS = "DELETE_SURVEYTEMPLATE_SUCCESS";
export const DELETE_SURVEYTEMPLATE_FAIL = "DELETE_SURVEYTEMPLATE_FAIL";
export const UPDATE_SURVEYTEMPLATE = "UPDATE_SURVEYTEMPLATE";
export const UPDATE_SURVEYTEMPLATE_SUCCESS = "UPDATE_SURVEYTEMPLATE_SUCCESS";
export const UPDATE_SURVEYTEMPLATE_FAIL = "UPDATE_SURVEYTEMPLATE_FAIL";
export const ADD_NEW_SURVEYTEMPLATE = "ADD_NEW_SURVEYTEMPLATE";
export const ADD_SURVEYTEMPLATE_SUCCESS = "ADD_SURVEYTEMPLATE_SUCCESS";
export const ADD_SURVEYTEMPLATE_FAIL = "ADD_SURVEYTEMPLATE_FAIL";
export const SURVEYTEMPLATE_RESET_CREATE = "SURVEYTEMPLATE_RESET_CREATE";
